import { Response } from "../api.interface";
import { WishListRes, GetWishListReq, DeleteWishReq } from "./wishList.interface";
import newColorAxiosInstance from "@/common-components-src/api/new-color-axiosInstance";

// 获取心愿单列表
export const fetchGetWishList = (params: GetWishListReq): Promise<Response<WishListRes>> => {
  return newColorAxiosInstance
    .post<Response<number>>("user_wishlist_getList", undefined, { params })
    .then((response: any) => response.data)
    .catch((err: any) => err);
};

// 删除愿望单
export const fetchDeleteWish = (params: DeleteWishReq): Promise<Response<number>> => {
  return newColorAxiosInstance
    .post<Response<number>>("user_wishlist_cancel", undefined, { params })
    .then((response: any) => response.data)
    .catch((err: any) => err);
};
